import Phaser from "phaser";
import InputTextPlugin from 'phaser3-rex-plugins/plugins/inputtext-plugin.js';
import UIPlugin from 'phaser3-rex-plugins/templates/ui/ui-plugin.js';
import GameStage from './scenes/game/index';
import Instruction from "./scenes/instruction";
import Introduction from "./scenes/introduction";
import Leaderboard from "./scenes/leaderboard";
import CountDown from "./scenes/CountDown";
import GameOver from "./scenes/GameOver";
import Prizes
    from "./scenes/prizes";
const config = {
    type: Phaser.AUTO,
    backgroundColor: '#fffdea',
    scale: {
        parent: 'phaser-example',
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        width: 1080,
        height: 1920
    },
    physics: {
        default: 'arcade',
        arcade: {
            // gravity: { y: 800 },
            debug: true
        },
        fps: { // not sure if this is even doing anything
            max: 60,
            min: 20,
            target: 60,
        }
    },
    dom: {
        createContainer: true
    },
    plugins: {
        global: [
            {
                key: 'rexInputTextPlugin',
                plugin: InputTextPlugin,
                start: true
            }
            // ...
        ],
        scene: [{
            key: 'rexUI',
            plugin: UIPlugin,
            mapping: 'rexUI'
        },
            // ...
        ]
    },
    soundSetting: true
    
}

const game = new Phaser.Game(config);

game.config.soundSetting = true;

game.scene.add('Introduction', Introduction);
game.scene.add('CountDown', CountDown);
game.scene.add('Instruction', Instruction);
game.scene.add('GameStage', GameStage);
game.scene.add('Leaderboard', Leaderboard);
game.scene.add('Prizes', Prizes);
game.scene.add('GameOver', GameOver);

game.scene.start('Introduction');